var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 7C15.5 6.50754 15.403 6.01991 15.2145 5.56494C15.0261 5.10997 14.7499 4.69657 14.4017 4.34835C14.0534 4.00013 13.64 3.72391 13.1851 3.53545C12.7301 3.347 12.2425 3.25 11.75 3.25C11.2575 3.25 10.7699 3.347 10.3149 3.53545C9.85997 3.72391 9.44657 4.00013 9.09835 4.34835C8.75013 4.69657 8.47391 5.10997 8.28545 5.56494C8.097 6.01991 8 6.50754 8 7C8 7.49246 8.097 7.98009 8.28545 8.43506C8.47391 8.89003 8.75013 9.30343 9.09835 9.65165C9.44657 9.99987 9.85997 10.2761 10.3149 10.4645C10.7699 10.653 11.2575 10.75 11.75 10.75C12.2425 10.75 12.7301 10.653 13.1851 10.4645C13.64 10.2761 14.0534 9.99987 14.4017 9.65165C14.7499 9.30343 15.0261 8.89003 15.2145 8.43506C15.403 7.98009 15.5 7.49246 15.5 7ZM6.75 7C6.75 5.67392 7.27678 4.40215 8.21447 3.46447C9.15215 2.52678 10.4239 2 11.75 2C13.0761 2 14.3479 2.52678 15.2855 3.46447C16.2232 4.40215 16.75 5.67392 16.75 7C16.75 8.32608 16.2232 9.59785 15.2855 10.5355C14.3479 11.4732 13.0761 12 11.75 12C10.4239 12 9.15215 11.4732 8.21447 10.5355C7.27678 9.59785 6.75 8.32608 6.75 7ZM4.25 20.75H19.25C19.2031 17.6367 16.6641 15.125 13.5352 15.125H9.96484C6.83984 15.125 4.30078 17.6367 4.25 20.75ZM3 20.8398C3 16.9922 6.11719 13.875 9.96484 13.875H13.5352C17.3828 13.875 20.5 16.9922 20.5 20.8398C20.5 21.4805 19.9805 22 19.3398 22H4.16016C3.51953 22 3 21.4805 3 20.8398Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsericon);
export default __webpack_public_path__ + "static/media/usericon.46532fe29fe3c718b6afd3af6859f13f.svg";
export { ForwardRef as ReactComponent };